import TemplatesDashboard from './TemplatesDashboard';

export default TemplatesDashboard; 